import {
  ADD_HOBBIES,
  ADD_HOBBIES_FAILURE,
  ADD_HOBBIES_SUCCESS,
  EDIT_HOBBIES,
  EDIT_HOBBIES_FAILURE,
  EDIT_HOBBIES_SUCCESS,
} from '../Actiontype';

export const AddHobbies = data => ({
  payload: data,
  type: ADD_HOBBIES,
});
export const AddHobbiesSuccess = response => ({
  payload: response,
  type: ADD_HOBBIES_SUCCESS,
});
export const AddHobbiesFailure = response => ({
  payload: response,
  type: ADD_HOBBIES_FAILURE,
});
export const EditHobbies = data => ({
  payload: data,
  type: EDIT_HOBBIES,
});
export const EditHobbiesSuccess = response => ({
  payload: response,
  type: EDIT_HOBBIES_SUCCESS,
});
export const EditHobbiesFailure = response => ({
  payload: response,
  type: EDIT_HOBBIES_FAILURE,
});
